import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { createBudget } from 'loot-core/client/actions';

export default function StartDemo() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  dispatch(
    createBudget(
      searchParams.get('isTestMode') === '1'
        ? { testMode: true }
        : { demoMode: true },
    ),
  );

  return <>Creating demo</>;
}
